import styled from 'styled-components'

export const ResumeExamplePopoverTitle = styled.p<{
  color?: string
}>`
  color: ${({ theme, color }) => theme[color]};
  font-weight: bold;
`
